// extracted by mini-css-extract-plugin
export default {"link":"CellContentFIO_link__WRvNy","birthday":"CellContentFIO_birthday__yf25s","placeHolderShimmer":"CellContentFIO_placeHolderShimmer__kyfx1"};